import { render, staticRenderFns } from "./ContentEditorDetails.vue?vue&type=template&id=3d2ac152&scoped=true"
import script from "./ContentEditorDetails.vue?vue&type=script&lang=js"
export * from "./ContentEditorDetails.vue?vue&type=script&lang=js"
import style0 from "./ContentEditorDetails.vue?vue&type=style&index=0&id=3d2ac152&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2ac152",
  null
  
)

export default component.exports